import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const authShop = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: 'Bearer endpei5haTpzaG9wLXNlcnZpY2VAY2hlY2stYnJhbmNocw=='
    }
  })

const powerbuyShopServicesApi = {
  checkBranch: (request) => {
    const { config } = request
    return authShop().get('/shop-service-branchs/check-branch', config)
  },
  getBranchMain: (request) => {
    const { config } = request
    return instance().get('/powerbuy-shop-service/branchs/main', config)
  },
  getBranchSub: (request) => {
    const { config } = request
    return instance().get('/powerbuy-shop-service/branchs/sub', config)
  },
  getBranchList: (request) => {
    const { config } = request
    return instance().get('/powerbuy-shop-service/branchs/list', config)
  },
  importBranch: (request) => {
    const { data } = request
    return instance().post('/powerbuy-shop-service/import-branchs', data)
  },
  importStock: (request) => {
    const { data } = request
    return instance().post('/powerbuy-shop-service/import-stock', data)
  }
}

export default powerbuyShopServicesApi



// WEBPACK FOOTER //
// ./src/api/powerbuy-shop-services.js